import { getScorerRubricTooltipRows } from '@fruitful/llm-service-shared';
import type { ReactElement, ReactNode } from 'react';
import { InfoButtonWithTooltip, TooltipTrigger, XStack } from 'smoothie';

export const ScorerValueWithRubric = ({
    scorerId,
    children,
    withInfoButton = false,
}: {
    score: number;
    scorerId: string;
    children: ReactNode;
    withInfoButton?: boolean;
}): ReactElement => {
    const tooltip = getScorerRubricTooltipRows(scorerId);
    if (tooltip == null) {
        return <>{children}</>;
    }

    if (withInfoButton) {
        return (
            <XStack alignItems="center" gap={4} flexShrink={0}>
                {children}
                <InfoButtonWithTooltip tooltipContent={tooltip} subtle />
            </XStack>
        );
    }

    return <TooltipTrigger tooltipContent={tooltip}>{children}</TooltipTrigger>;
};
